import React, { CSSProperties, ReactNode, useRef } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './EditHealthCheckSettingsDialog.module.css';
import JsonSettingsEditor from '../../main/JsonSettingsEditor/JsonSettingsEditor';
import { useEditHealthCheckSettingsMutation } from '../../../generated/graphql';

type EditHealthCheckSettingsDialogProps = {
    onClose: () => void,
    id: string,
    settings: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const EditHealthCheckSettingsDialog = (props: EditHealthCheckSettingsDialogProps) => {
    const { id, style, visible, settings, onClose } = props;
    const dataRef = useRef<any>(null);
    const [editHealthCheckSetting, editHealthCheckSettingResult] = useEditHealthCheckSettingsMutation();

    const handleOkClick = async () => {
        try {
            const result = JSON.stringify(dataRef.current);

            await editHealthCheckSetting({
                variables: {
                    healthCheckId: id,
                    settings: result
                }
            });

            onClose();
        }
        catch {
            // handled by mutation result
        }
    };

    return (
        <DialogBase
            title="Edit Health Check Settings"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            className={styles.EditHealthCheckSettingsDialog}
            style={style}
            width="640px"
            data-testid="EditHealthCheckSettingsDialog"
            isLoading={editHealthCheckSettingResult.loading}
            onOkClick={handleOkClick}>
            <JsonSettingsEditor
                visualizeOnly={false}
                editable
                style={{ minHeight: '200px', maxHeight: '500px' }}
                settings={settings}
                onDataChange={(data) => { dataRef.current = data; }} />
        </DialogBase>
    );
};

export default EditHealthCheckSettingsDialog;